import { Datasource, Pipeline } from "@features/data-platform/types";
import { Chain } from "@util/constants";
import { clone } from "lodash";

// It seems like dashboard uses some constants for network & chains that aren't used elsewhere in the Alchemy system.
// We need to map these to the correct values.
const PIPELINE_NETWORK_MAPPING: Record<
  string,
  Pipeline["datasource"]["network"]
> = {
  MATIC_MAINNET: "POLYGON_MAINNET",
};

const PIPELINE_CHAIN_MAPPING: Record<string, Datasource["chain"]> = {
  matic: Chain.POLYGON,
};

export const convertPipelineNetworkToDashboardNetwork = (
  network:
    | Pipeline["datasource"]["network"]
    | keyof typeof PIPELINE_NETWORK_MAPPING,
): Pipeline["datasource"]["network"] => {
  if (network in PIPELINE_NETWORK_MAPPING) {
    return PIPELINE_NETWORK_MAPPING[network];
  }
  return network as Pipeline["datasource"]["network"];
};

export const convertDashboardNetworkToPipelineNetwork = (
  network: Datasource["network"],
): Pipeline["datasource"]["network"] => {
  const key = Object.keys(PIPELINE_NETWORK_MAPPING).find(
    (key) => PIPELINE_NETWORK_MAPPING[key] === network,
  );
  if (key) {
    return key as Pipeline["datasource"]["network"];
  }
  return network;
};

export const convertDashboardChainToPipelineChain = (
  chain: Datasource["chain"] | keyof typeof PIPELINE_CHAIN_MAPPING,
): Datasource["chain"] => {
  if (chain in PIPELINE_CHAIN_MAPPING) {
    return PIPELINE_CHAIN_MAPPING[chain];
  }
  return chain as Datasource["chain"];
};

export const buildIncomingPipeline = (pipeline: Pipeline): Pipeline => {
  const copy = clone(pipeline);
  copy.datasource.network = convertPipelineNetworkToDashboardNetwork(
    copy.datasource.network,
  );
  return copy;
};

export const buildIncomingDataSource = (datasource: Datasource): Datasource => {
  const copy = clone(datasource);
  copy.network = convertPipelineNetworkToDashboardNetwork(datasource.network);
  copy.chain = convertDashboardChainToPipelineChain(datasource.chain);
  return copy;
};
